import { InputLabel, Input, FormHelperText } from "@mui/material";
import { FormControl } from "@mui/material";
import { useState } from "react";

interface FormOption {
  name: string;
  value?: string;
  onChange: (value?: string) => void;
}
export function ComponentEditorOption(props: FormOption): JSX.Element {
  const [value, setValue] = useState(props.value);
  function dispatchValue() {
    props.onChange(value);
  }
  return (
    <FormControl>
      <InputLabel htmlFor={props.name}>{props.name}</InputLabel>
      <Input
        type="text"
        id={props.name}
        aria-describedby={props.name + "-helper-text"}
        onBlur={dispatchValue}
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      <FormHelperText id={props.name + "-helper-text"}>
        Configure form component.
      </FormHelperText>
    </FormControl>
  );
}
